import GlobalVariable from '@/global/global-variable'

// websoket路径 NFC
const wsUrlNfc = 'ws://127.0.0.1:50001/readNFCData';

// ID card 路径 NFC
//const readIDCard = '/local24010/ZKIDROnline/ScanReadIdCardInfo?OP-DEV=1&CMD-URL=4';
const readIDCard = GlobalVariable.BASE_PATH_IDCARD + '/ZKIDROnline/ScanReadIdCardInfo?OP-DEV=1&CMD-URL=4';

// 实时数据 ws
const positionWs = GlobalVariable.WS_POSITION_PATH;

// websoket路径 jkkcPlayer
const wsUrlPlayer = 'ws://127.0.0.1:6060';

export default {
	// websoket路径 NFC
	wsUrlNfc,
	// ID card 路径 NFC
	readIDCard,
	// 实时数据 ws
	positionWs,
	// websoket路径 jkkcPlayer
	wsUrlPlayer,
}



// WEBPACK FOOTER //
// ./src/request/api-nfc_ws.js